import { http } from 'api';

const AREA = 'facility';

export const getNotValidatedClassesApi = () => http.get(`${AREA}/not-validated-classes`);
